import { ChangeDetectionStrategy, Component, Input,  OnInit } from "@angular/core";
import { Utilities } from "@tylertech/shared-module";
import { KeyValue } from "@tylertech/tyler-api-types";

@Component({
    selector: "metadata-script",
    templateUrl: "./metadataScript.tmpl.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MetadataScriptComponent implements OnInit 
{
    @Input() private readonly model: Readonly<KeyValue[]>;

    scriptContainerId: string;
    ngOnInit(): void
    {
        const self = this;
        this.scriptContainerId = Utilities.generateRandomGuid();
        requestAnimationFrame(() =>
        {
            const scriptContainer = document.getElementById(self.scriptContainerId);
            const scriptElement = document.createElement("script");
            scriptElement.setAttribute("type", "text/javascript");
            for (const attr of this.model)
            {
                scriptElement.setAttribute(attr.Key, attr.Value);
            }
            scriptContainer.appendChild(scriptElement);
        });
    }
}
